export const resources = {
    en: {
        translation: {
            myBikesHeading: 'My Bikes',
            myBike: 'My Bike',
            registerBike: 'Register Bike',
            searchBikesLabel: 'Search your bikes',
            searchInRegister: 'Search in register',
            registerBikeSidebar: 'Register bike',
            myBikesSidebar: 'My bikes',
            stolenBikes: 'Stolen bikes',
            ownershipTransfer: 'Ownership transfer',
            webshop: 'Webshop',
            insurance: 'Insurances',
            messages: 'Messages',
            account: 'Account',
            support: 'Support',
            insurancePolicies: 'Insurance policies',
            bikes: 'Bikes',
            addBikePageTitle: 'Register your bike',
            createSubscriptionTitle: 'Register for Bikekey bike registry',
            purchaseOrRedeemExtraBikeTitle: 'Buy or redeem bike registration',
            purchaseExtraBikeTitle: 'Buy extra bike registration',
            purchaseExtraBikeDescription:
                'Buy extra bike registration for your bikes for 100,- kr. per piece as a one-time payment',
            purchaseExtraBikeButton: 'Buy extra bike registration',
            bike: 'Bike',
            eBike: 'e-Bike',
            bikeDetails: 'Bike Details',
            identification: 'Identification',
            active: 'Active',
            makeSearchable: 'Make searchable',
            private: 'Private',
            reportedStolen: 'Reported stolen',
            editBike: 'Edit bike',
            frameNumber: 'Frame number',
            missing: 'MISSING',
            licensePlate: 'License plate',
            optional: 'OPTIONAL',
            mayBeRegistered: 'May be registered',
            brand: 'Brand',
            category: 'Category',
            color: 'Color',
            notProvided: 'Not provided',
            colors: {
                black: 'Black',
                gray: 'Gray',
                blue: 'Blue',
                green: 'Green',
                white: 'White',
                red: 'Red',
                special: 'Special Color',
                orange: 'Orange',
                yellow: 'Yellow',
                brown: 'Brown',
                purple: 'Purple',
                multi: 'Multi',
                pink: 'Pink',
            },
            reportBikeFound: 'Report bike found',
            seePublicDisplay: 'See public display',
            documents: 'Documents',
            equipment: 'Equipment',
            type: 'Type',
            myBikeDetailsBikeTabDescription:
                'The unique IDs and serial numbers that connect your bike to you',
            detailsAndCharacteristicsOfBike: 'Details and characteristics of your bike',
            model: 'Model',
            yes: 'Yes',
            no: 'No',
            buy: 'Buy',
            deleteBike: 'Delete bike',
            errors: {
                tagAlreadyRegistered: 'Plate "{{bikekeyId}}" is already registered',
                tagNotRegistered: 'Invalid Plate ID "{{bikekeyId}}"',
                fillInFieldsFirst: 'Please fill in all fields first',
                validationError: 'Please fill in all fields',
            },
            viewTheftReport: 'View theft report',
            reportBikeStolen: 'Report bike stolen',
            bikeCannotBeIdentified: 'Your bike cannot be identified!',
            toAddFrameAndLicensePlate: 'to add frame number and license plate ID',
            picture: 'Picture',
            download: 'Download',
            addDocumentToBike: 'Add a document to your bike.',
            youCanAddFrameNumber: 'You can add frame number, receipt, lock certificate or other.',
            addEquipmentToBike: 'Add equipment to your bike',
            addBatteryOrOtherAccessory: 'Add a battery or other accessory to your bike.',
            battery: 'Battery',
            seeBatteriesForEbike: 'See batteries associated with your e-bike.',
            serialNumber: 'Serial number',
            plateId: 'Plate-ID',
            bikeLocks: 'Bike locks',
            seeBikeLocks: 'See bike locks associated with your bike.',
            brandAndModel: 'Brand & Model',
            VarefaktaNumber: 'Varefakta number',
            accessories: 'Accessories',
            addVariousAccessories: 'Add various accessories to your bike.',
            logout: 'Log out',
            details: 'Details',
            importantInformation:
                'Important information about your bike that allows others to identify it through the registry.',
            takePictureFrameNumber: 'Take a picture of the frame number on your bike',
            takeOneOrMorePictures:
                'Take one or more pictures of the frame number so that the entire frame number can be read among them.',
            pictureOfLicensePlate: 'Picture of the license plate on your bike',
            takePictureLicensePlate: 'Take a picture of the license plate on your bike',
            takePictureLicensePlateCode:
                'Take a picture of the license plate of your bike so that it is possible to read the code under the QR code.',
            publicPicture: 'Public picture',
            important: 'Important',
            bikePictureOthersSee:
                'The picture of your bike that others can see when searching the registry.',
            takePictureEntireBike: 'Take a picture of your entire bike',
            makeSureBikeVisible:
                'Make sure that as much as possible of your bike can be seen in the picture - this makes it easier to identify for others.',
            pictureOfReceipt: 'Picture of the bike receipt',
            takePictureReceipt: 'Take a picture of the receipt for your bike',
            pictureOfLockProofs: 'Picture of lock proofs',
            takePictureLockProofs: 'Take a picture of one or more lock proofs',
            pictureOfFrameNumber: 'Picture of frame number',
            bikeNickName: 'Name your bike',
            save: 'Save',
            saved: 'Saved',
            nicknameDescription: 'Name your bike, for example: "My black racer"',
            reset: 'Reset',
            enterFrameNumber: 'Enter frame number',
            doubleCheckFrameNumber: 'Double-check your frame number',
            frameNumberMatchWarning:
                'The frame number entered must match the one on the bike frame and therefore it may <strong> differ </strong> from the frame number on your receipt.',
            findFrameNumber: 'Where can I find the frame number?',
            frameNumberLocation:
                "The bike's frame number can be located in several different places. Below you can see the most common places on the bike where the frame number appears.",
            placeNumberPlate: 'Where should I place the number plate?',
            numberPlatePlacement:
                'We recommend placing your number plate at the top of the seat tube facing the direction of travel, the top tube, or the head tube. The most important thing is that it is placed somewhere where it can be seen easily and not behind any parts.',
            findCode: 'Where can I find the code?',
            findNumberPlateId: 'Find your plate-ID here',
            numberPlateIdLocation:
                'Your plate-ID is the unique sequence of numbers and letters that you find under the QR code.',
            seeExample: 'See example',
            back: 'Back',
            clickToTakeOrUploadPicture: 'Click to take or upload picture',
            whereToFindPlateId: 'Where do I find my plate-ID?',
            howToAttachNumberPlates: 'How do I attach the number plates?',
            plateShapesAndPlacement:
                'Rectangular for larger tubes - round for rear fender or under the bottom bracket',
            recommendedPlatePlacement:
                'Our recommendation is to attach the larger rectangular sticker to one of the larger tubes on your bike. We recommend attaching the round one to the rear fender, or under the bottom bracket if you do not have a rear fender.',
            enterId: 'Enter ID',
            takePictureOfPlate: 'Take a picture of the number plate on your bike',
            saveAndFinish: 'Save & finish',
            continue: 'Continue',
            asOnReceipt: 'As it appears on the receipt, if you have it',
            purchaseDate: 'Purchase date',
            selectDate: 'Select date',
            selectPastDate: 'Please select a date in the past',
            purchasePriceDkk: 'Purchase price in DKK',
            privateBikePictures: 'Pictures of your bike that only you can access on Bikekey',
            privatePictures: 'Private pictures',
            receipt: 'Receipt',
            form: 'Form',
            lockCertificate: 'Lock Certificate',
            other: 'Other',
            extraDetails: 'Extra details',
            bikePreventiveFeatures:
                'Features and accessories for your bike with preventive properties that protect it against theft',
            bikeDNA: {
                whatIsBikeDNA: 'What is BikeDNA?',
                description:
                    'BikeDNA is an optional add-on to your bike registration. BikeDNA is a transparent DNA liquid that contains thousands of microdots that light up under UV light, enabling the police in 40 countries to identify your found belongings and link criminals to a possible theft.',
                readMoreOnWebShop: 'You can read more under the menu item <strong>Webshop</strong>',
                findCode: 'Where can I find my BikeDNA code?',
                codeLocation: 'Here you will find your BikeDNA code',
                codeLocationDescription: 'See your BikeDNA code on the image marked in green.',
            },
            selectType: 'Select type',
            select: 'Select',
            searchForBrand: 'Search for brand',
            bikeData: 'Bike data',
            equipmentAndAccessoriesDescription:
                'Equipment and accessories associated with your bike',
            Dame: 'Female',
            Herre: 'Male',
            Unisex: 'Unisex',
            addEquipment: 'Add {{equipment}} to your bike',
            lock: 'Lock',
            categories: {
                city: 'City',
                mountainTour: 'Mountain',
                road: 'Road',
                racer: 'Racer',
                cargo: 'Cargo',
                hybrid: 'Hybrid Bike',
                cruiser: 'Cruiser',
                folding: 'Folding',
                bmx: 'BMX',
            },
            otherType: 'Other type',
            profile: {
                name: 'Name',
                languageSection: 'Language',
                languageSectionDesc: 'Select your preferred system language',
                systemLanguageLabel: 'System language',
                languageDanish: 'Danish',
                languageEnglish: 'English',
                languageNorwegian: 'Norwegian',
                regionLabel: 'Region',
                regionBikekeyDenmark: 'Bikekey Denmark',

                personalInformationTitle: 'Personal Information',
                personalInformationDesc: 'Update your personal information here',
                verificationTitle: 'Verification',
                verificationDesc: 'See the status of your profile verification here',
                resendEmailSuccess: 'Verification email was sent',
                mitid: 'MitID',
                verifyNow: 'Verify now',
                email: 'Email',
                resendMail: 'Resend mail',
                deleteUser: 'Delete user',
                serverNotResponded: 'Server did not respond correctly',
                changesSavedTitle: 'Changes saved',
                changesSavedDesc: 'Your account information was updated successfully.',
                changesPartiallySavedTitle: 'Changes partially saved',
                changesPartiallySavedDesc:
                    'We’ve sent an email to your new address—please click the link in that email to confirm your change. All other changes were saved successfully.',
                weSentYouAnEmail: 'We’ve sent you an email',
                weSentYouAnEmailDesc:
                    'We’ve sent an email to your new address—please click the link to confirm your change.',
                cancelButton: 'Cancel',
                saveButton: 'Save',
                address: 'Address',
                streetNameAndNumber: 'Street name & number',
                city: 'City',
                postalCode: 'Postal code',
                floor: 'Floor',
                side: 'Side',
                optionalDoor: 'Optional door',
                mobile: 'Mobile',
                phone: 'Phone',
                verification: 'Verification',
                seeVerificationStatus: 'See the status of your profile verification here',
                resendEmail: 'Resend email',
                pendingVerification: 'Pending verification',
                verified: 'You are verified',
                systemLanguage: 'System language',
                region: 'Region',
                navigateToNafCustomerPortal: 'Navigate to NAF customer portal',
                navigateToNafPurchasePage: 'Navigate to NAF purchase page',
                nafPeriodeCustomer:
                    'You have a Vipps subscription with NAF, cancel via the Vipps app, or make changes by contacting Bikekey',
                resetPassword: {
                    title: 'Select new password',
                    description: 'Enter your desired new password below.',
                    enterNewPassword: 'Enter password',
                    enterNewPasswordAgain: 'Enter password again',
                    save: 'Save',
                    logInInstead: 'Log in instead',
                    checkMail: 'Check your mail',
                    checkMailDescription:
                        'We have sent a link to reset your password to {{emailAddress}}',
                    checkMailDescriptionNoMail:
                        'Did you not receive an email? Check your spam filter.',
                    sendNewMail: 'Send new mail',
                    forgotPassword: 'I forgot my password',
                    forgotPasswordDescription: 'No problem - let us reset it for you',
                    enterEmail: 'Enter email',
                    resetPassword: 'Reset password',
                    invalidEmailAlert: 'Ups - E-mail not valid',
                    invalidEmailAlertDescription: 'Check if email address is spelled correctly',
                    invalidEmailAlertNoMail:
                        'We cannot find a user with the given email address - check if the email address is spelled correctly',
                    invalidEmailAlertDescriptionNoMail:
                        'We cannot find a user with the given email address - check if the email address is spelled correctly',
                },
            },
            edit: 'Edit',
            nameNotProvided: 'Name not provided',
            supportChat: 'Support chat',
            validButForeignOrManufacturerFrameNumber:
                'Valid but foreign or manufacturer frame number',
            takeOrUploadPhotoToHelpFindBike: 'Take or upload a photo to help find your bike',
            oopsInvalidId: 'Oops - the entered ID is not valid',
            searchNoResultTitle: 'Search yielded no results',
            searchNoResultDescription:
                'Your search unfortunately did not yield a result. Please check that the frame or ID number is entered correctly.',
            youOwnThisBike: 'You own this bike',
            contactOwner: 'Contact owner',
            requestOwnership: 'Request ownership',
            loading: 'Loading...',
            loadingMessages: 'Loading conversations...',
            noMessages: 'There are no messages',
            startConversation:
                'Start a conversation by scanning a Bikekey plate or search for frame number.',
            inbox: 'Inbox',
            searchMessages: 'Search messages',
            becomePartOfBikekey: 'Become a part of Bikekey',
            registerOnDenmarksBikeRegistry: "Register on Denmark's bike registry",
            enterYourEmail: 'Enter your email address',
            enterYourPassword: 'Enter your password',
            enterYourPasswordAgain: 'Repeat your password',
            acceptPrivacyAndTerms:
                'By creating a user on Bikekey you accept our privacy policy and terms of service.',
            byCreatingUserOnBikekeyYouAccept: 'By creating a user on Bikekey you accept our',
            privacyPolicy: 'privacy policy',
            termsOfService: 'terms of service',
            and: 'and',
            createUser: 'Create user',
            alreadyHaveAnAccount: 'Already have an account?',
            login: 'Login',
            loginToBikekey: 'Login to Bikekey',
            welcomeBack: 'Welcome back! Login here below',
            logInWithMitID: 'Log in with',
            enterEmail: 'Enter email',
            enterPassword: 'Enter password',
            forgotPassword: 'I forgot my password',
            dontHaveAccount: "Don't have an account?",
            signUp: 'Sign up',
            searchFrameOrId: 'Search for frame or ID',
            search: 'Search',
            changeUser: 'Change user',
            createBusinessUser: 'Create business user',
            pleaseSelectARegion: 'Please select a region',
            reportBikeFoundAlert: 'You are about to report your bike found',
            reportBikeFoundAlertDescription:
                'You need to approve with MitID to report your bike found. If you report your bike found, your report will be deleted and your bike will be deregistered as stolen on Bikekey.',
            reportBikeFoundAlertDescriptionNo:
                'If you report your bike found, your report will be deleted and your bike will be deregistered as stolen on Bikekey.',
            reject: 'Reject',
            helpCenter: 'Help center',
            redeemBikeRegistrationTitle: 'Redeem bike registration',
            redeemBikeRegistrationDescription:
                'Have you bought and received a plate, e.g., via our webshop or from a dealer? Redeem it below',
            redeemBikeRegistrationButton: 'Redeem bike registration',
            registerBikeTitle: 'Make bikes searchable and identifiable',
            registerBikeDescription:
                'Below is an overview of all available bikes linked to your account. Register your bikes with a name and the corresponding plate ID. We also recommend that you add a picture of the bike.',
            bikeNameLabel: 'Bike name',
            required: 'Required',
            bikeNamePlaceholder: 'Enter bike name',
            plateIdLabel: 'Plate ID',
            plateIdPlaceholder: 'Plate ID',
            addBikeButton: 'Add a bike',
            registerButton: 'Register',
            recommended: 'Recommended',
            purchase_complete: 'Your purchase at Bikekey is complete.',
            register_info: 'You can only register your bikes once you have received our stickers.',
            delivery_info: 'You will receive the stickers by mail within 7–10 business days.',
            understood_button: 'Understood',
            waitingConfirmation: 'Waiting for confirmation',
            paymentProcessingInfo:
                'It may take a few minutes for the payment to process. You can return to the app and wait. If you believe something is wrong, feel free to contact us!',
            reloadButton: 'Reload again',
            goToApp: 'Go to the app',
            nafMedlemsnummer: 'NAF membership number',
            nafMedlemsnummerValidering: 'NAF membership number must be 6–8 characters long',
            noSubscription: 'No subscription linked to your account',
            subscriptionRequiredInfo:
                'You need an active subscription to add bikes to your Bikekey account.',
            purchaseMembershipButton: 'Purchase membership',
            areYouNafMember: 'Are you a NAF member?',
            personalInfoTitle: 'Your personal information',
            personalInfoSubtitle:
                'Check that the information about you below is correct. Fill in any missing details.',
            firstName: 'First name',
            lastName: 'Last name',
            streetAndNumber: 'Street address & number',
            city: 'City',
            postalCode: 'Postal code',
            floor: 'Floor',
            side: 'Side',
            door: 'Optional door',
            mobile: 'Mobile',
            telephone: 'Telephone',
            addressTitle: 'Address',
            telephoneTitle: 'Telephone',
            next: 'Next',
            report: 'Report',
            overviewTitle: 'Overview',
            sectionHeader: 'Section',
            statusHeader: 'Status',
            goToHeader: 'Go to',
            personalInfo: 'Your information',
            insuranceAndValue: 'Insurance company and value',
            bikeInfo: "Your bike's information",
            culpritInfo: 'Information about the culprit',
            timeAndPlace: 'Time and place of theft',
            sendReport: 'Submit report',
            insuranceInfoSubtitle: "Add details about your insurance and your bike's value",
            insuranceSingle: 'Insurance',
            isBikeInsured: 'Is your bike insured?',
            chooseInsuranceCompany: 'Choose insurance company',
            bikePriceQuestion: 'What did the bike cost?',
            bikePriceDescription:
                "Enter the full amount in Danish kroner, including equipment. If you're unsure, estimate what a similar bike would cost.",
            enterAmount: 'Enter amount',
            policeReportTitle: 'Should Bikekey report your bike as stolen to the police?',
            policeReportDescription:
                'Choose whether we should report the theft to the police on your behalf.',
            noIPreferMyself: 'No, I will do it myself',
            cprNumber: 'CPR number',
            enterCprNumber: 'Enter your CPR number',
            missingStepAlert:
                'Please make sure all steps and fields are filled out before continuing. Sections that are missing are marked with a red exclamation mark.',
            missingAcknowledgeTitle: 'Please confirm our terms',
            missingAcknowledgeMessage:
                'Please confirm that you understand and accept the terms above in order to report your bike as stolen through Bikekey.',
            completeAllSteps: 'Please complete all steps to continue',
            bikeInfoTitle: "Your bike's information",
            bikeInfoSubtitle:
                'Check that the information below about your bike is correct. Fill in any missing information.',
            frameNumberDescription: "Enter the frame number as it appears on your bike's frame.",
            bikeCategory: 'Bike category',
            bikeCategoryDescription: 'Specify which category your bike belongs to.',
            colorDescription: 'Enter the color of your bike',
            isElectric: 'Electric bike',
            isElectricDescription: 'Is your bike an electric bike?',
            batteryDescription: 'Are you in possession of the battery?',
            lockStatus: 'Locking method',
            lockStatusDescription: 'How was the bike locked when it was stolen?',
            writeHere: 'Write here...',
            or: 'Or',
            batteryIntegrated: 'Battery is integrated in bike',
            chooseColor: 'Choose color',
            chooseCategory: 'Choose category',
            timeAndLocationTitle: 'Time and place of theft',
            timeAndLocationSubtitle: 'Add details about when and where the theft occurred',
            lastSeenTitle: 'When did you last see the bike?',
            dateTimeDescription: 'Enter the date and time below.',
            discoveredTheftTitle: 'When did you discover the theft?',
            placeStolenTitle: 'Where was the bike stolen from?',
            placeStolenDescription: 'Select a location from the list',
            locationTitle: 'Location',
            locationDescription: 'Enter a location or choose from the map',
            choosePastDate: 'Please select a date in the past',
            chooseFallback: 'Choose',
            searchAddress: 'Search address',
            sendReportTitle: 'Submit report',
            sendReportSubtitle:
                'When you submit the report, it will be published on Bikekey and others may anonymously contact you to return your bike.',
            responsibilityAcknowledgement:
                'I understand that it is my own responsibility to report a claim to my insurance company if I wish to seek compensation.',
            dataShareAcknowledgement:
                'I understand that my report will be shared with my insurance company.',
            ownershipTransferAcknowledgement:
                'I understand that my bike registration will be transferred to my insurance company if I receive a compensation payment.',
            buyMembership: 'Buy membership',
            subscriptionAndPayment: 'Subscription and payment',
            checkSubscriptionStatus: 'Check the status of the subscription and payment method',
            invalidNafNumber: 'Invalid NAF number',
            successFoundTitle: 'Success! Your bike has been reported found!',
            goToBike: 'Go to bike',
            successFoundDescription:
                'We are happy that your bike has been found! We have deregistered it as stolen on Bikekey.',
            validId: 'Valid ID',
        },
    },
    da: {
        translation: {
            myBikesHeading: 'Mine cykler',
            myBike: 'Min cykel',
            registerBike: 'Tilføj cykel',
            searchBikesLabel: 'Søg i cykler',
            searchInRegister: 'Søg i register',
            registerBikeSidebar: 'Registrer cykel',
            myBikesSidebar: 'Mine cykler',
            stolenBikes: 'Stjålne cykler',
            ownershipTransfer: 'Ejerskabsflyt',
            webshop: 'Webshop',
            insurance: 'Forsikringer',
            messages: 'Beskeder',
            account: 'Konto',
            support: 'Support',
            insurancePolicies: 'Forsikringspolicer',
            bikes: 'Cykler',
            addBikePageTitle: 'Tilføj cykel',
            createSubscriptionTitle: 'Køb eller indløs cykelregistrering',
            requestMorePlatesInsurance: {
                title: 'Skal du bruge flere nummerplader?',
                description:
                    'Hvis du ønsker at bestille flere Bikekey cykelnummerplader, kan du gøre det ved at sende en e-mail til:',
                emailLb: 'cyklist@lb.dk',
            },
            purchaseRegistration: {
                title: 'Køb en cykelregistrering',
                description:
                    'Vælg mellem enkelt-registrering eller køb registreringer til hele husstanden',
                button: 'Køb registrering',
            },
            purchaseOrRedeemExtraBikeTitle: 'Køb eller indløs cykelregistrering',
            purchaseExtraBikeTitle: 'Køb ekstra nummerplader',
            purchaseExtraBikeDescription:
                'Køb ekstra nummerplader til dine cykler for 100,- kr. pr. stk. som engangsbetaling',
            purchaseExtraBikeButton: 'Køb ekstra nummerplader',
            bike: 'Cykel',
            eBike: 'El-cykel',
            bikeDetails: 'Cykeldetaljer',
            identification: 'Identifikation',
            active: 'Aktiv',
            makeSearchable: 'Gør søgbar',
            private: 'Privat',
            reportedStolen: 'Meldt stjålet',
            editBike: 'Rediger cykel',
            frameNumber: 'Stelnummer',
            missing: 'MANGLER',
            licensePlate: 'Nummerplade',
            optional: 'VALGFRI',
            mayBeRegistered: 'Kan være registreret',
            brand: 'Mærke',
            category: 'Kategori',
            color: 'Farve',
            notProvided: 'Ikke angivet',
            colors: {
                black: 'Sort',
                gray: 'Grå',
                blue: 'Blå',
                green: 'Grøn',
                white: 'Hvid',
                red: 'Rød',
                special: 'Speciel Farve',
                orange: 'Orange',
                yellow: 'Gul',
                brown: 'Brun',
                purple: 'Lilla',
                multi: 'Multi',
                pink: 'Pink',
            },
            reportBikeFound: 'Meld cykel fundet',
            seePublicDisplay: 'Se offentlig visning',
            documents: 'Dokumenter',
            equipment: 'Udstyr',
            type: 'Type',
            myBikeDetailsBikeTabDescription:
                'De unikke ID og serienumre der forbinder din cykel til dig',
            detailsAndCharacteristicsOfBike: 'Detaljer og kendetegn ved din cykel',
            model: 'Model',
            yes: 'Ja',
            no: 'Nej',
            buy: 'Køb',
            deleteBike: 'Slet cykel',
            errors: {
                tagAlreadyRegistered: 'Nummerpladen "{{bikekeyId}}" er allerede registreret',
                tagNotRegistered: 'Ugyldig Nummerplade-ID "{{bikekeyId}}"',
                fillInFieldsFirst: 'Venligst udfyld eksisterende cykler først',
                validationError: 'Venligst udfyld alle felter',
            },
            viewTheftReport: 'Se tyverianmeldelse',
            reportBikeStolen: 'Meld cykel stjålet',
            bikeCannotBeIdentified: 'Din cykel kan ikke identificeres!',
            toAddFrameAndLicensePlate: 'for at tilføje stelnummer og nummerplade-ID',
            picture: 'Billede',
            download: 'Download',
            addDocumentToBike: 'Tilføj et dokument til din cykel.',
            youCanAddFrameNumber: 'Du kan tilføje stelnummer, kvittering, låsebevis eller andet.',
            addEquipmentToBike: 'Tilføj udstyr til din cykel',
            addBatteryOrOtherAccessory: 'Tilføj et batteri eller andet tilbehør til din cykel.',
            battery: 'Batteri',
            seeBatteriesForEbike: 'Se batterier tilknyttet din el-cykel.',
            serialNumber: 'Serienummer',
            plateId: 'Nummerplade-ID',
            bikeLocks: 'Cykellåse',
            seeBikeLocks: 'Se cykellåse tilknyttet din cykel.',
            brandAndModel: 'Mærke & Model',
            VarefaktaNumber: 'Varefakta nummer',
            accessories: 'Tilbehør',
            addVariousAccessories: 'Tilføj diverse tilbehør til din cykel.',
            logout: 'Log ud',
            details: 'Detaljer',
            importantInformation:
                'Vigtige oplysninger om din cykel der gør det muligt for andre at identificerer din cykel via registret.',
            takePictureFrameNumber: 'Tag et billede af stelnummeret på din cykel',
            takeOneOrMorePictures:
                'Tag et ellere flere billeder af stelnummeret så at man blandt dem kan aflæse hele stelnummeret',
            pictureOfLicensePlate: 'Billede af nummerplade på din cykel',
            takePictureLicensePlate: 'Tag et billede af nummerpladen på din cykel',
            takePictureLicensePlateCode:
                'Tag et billede af nummerpladen på din cykel så det er muligt at aflæse koden under QR-koden',
            publicPicture: 'Offentligt billede',
            important: 'Vigtig',
            bikePictureOthersSee: 'Billedet af din cykel, som andre kan se ved register-søgning',
            takePictureEntireBike: 'Tag et billede af hele din cykel',
            makeSureBikeVisible:
                'Sørg for at så meget som muligt af din cykel kan ses på billedet - det gør den lettere at identificere for andre',
            pictureOfReceipt: 'Billede af kvittering på cykel',
            takePictureReceipt: 'Tag et billede af kvitteringen på din cykel',
            pictureOfLockProofs: 'Billede af låsebeviser',
            takePictureLockProofs: 'Tag et billede af et eller flere låsebeviser',
            pictureOfFrameNumber: 'Billede af stelnummer',
            bikeNickName: 'Navngiv cykel',
            save: 'Gem',
            saved: 'Gemt',
            nicknameDescription: 'Navngiv din cykel, f.eks.: "Min sorte racer"',
            reset: 'Nulstil',
            enterFrameNumber: 'Indtast stelnummer',
            doubleCheckFrameNumber: 'Dobbeltcheck dit stelnummer',
            frameNumberMatchWarning:
                'Det indtastede stelnummer skal matche det på cyklens stel og derfor kan det <strong> afvige </strong> fra stelnummeret på din kvittering.',
            findFrameNumber: 'Hvor kan jeg finde stelnummeret?',
            frameNumberLocation:
                'Cyklens stelnummer kan befinde sig flere forskellige steder. Nedenfor her kan du se de mest hyppige steder på cyklen hvor stelnummeret fremgår.',
            placeNumberPlate: 'Hvor skal jeg sætte nummerpladen?',
            numberPlatePlacement:
                'Vi anbefaler at placere din nummerplade øverst på sadelrøret mod køreretningen, overrøret eller kronrøret. Det vigtigeste er at den er sat et sted så den kan ses nemt og ikke bag dele.',
            findCode: 'Hvor finder jeg koden?',
            findNumberPlateId: 'Find dit nummerplade-ID her',
            numberPlateIdLocation:
                'Dit nummerplade-ID er den unikke sekvens af tal og bogstaver som du finder under QR-koden.',
            seeExample: 'Se eksempel',
            back: 'Tilbage',
            clickToTakeOrUploadPicture: 'Klik for at tage eller uploade billede',
            whereToFindPlateId: 'Hvor finder jeg mit nummerplade-ID?',
            howToAttachNumberPlates: 'Hvordan påsætter jeg nummerpladerne?',
            plateShapesAndPlacement:
                'Rektangulær til større rør - rund til bagskærm eller under kranken',
            recommendedPlatePlacement:
                'Vores anbefaling er at påsætte det større rektangulære mærkat på et af de større rør på din cykel. Den runde anbefaler vi at påsætte bagskærmen, eller under kranken såfremt du ingen bagskærm har.',
            enterId: 'Indtast ID',
            takePictureOfPlate: 'Tag et billede af nummerpladen på din cykel',
            saveAndFinish: 'Gem & afslut',
            continue: 'Videre',
            asOnReceipt: 'Som det står på kvitteringen, hvis du har den',
            purchaseDate: 'Købsdato',
            selectDate: 'Vælg dato',
            selectPastDate: 'Vælg venligst en dato i fortiden',
            purchasePriceDkk: 'Købspris i DKK',
            privateBikePictures: 'Billeder af din cykel, som du kun selv kan tilgå på Bikekey',
            privatePictures: 'Private billeder',
            receipt: 'Kvittering',
            form: 'Blanket',
            lockCertificate: 'Låsebevis',
            other: 'Andet',
            extraDetails: 'Ekstra detaljer',
            bikePreventiveFeatures:
                'Kendetegn og tilbehør til din cykel med præventive egenskaber der sikrer den mod tyveri',
            bikeDNA: {
                whatIsBikeDNA: 'Hvad er BikeDNA?',
                description:
                    'BikeDNA er et ekstra tilkøb til din cykelregistrering. BikeDNA er en transparent DNA-væske som indeholder tusindvis af mikroprikker der lyser op under UV, som gør det muligt for politiet i 40 lande at identificere dine fundne ejendele og knytte kriminelle til et eventuelt tyveri.',
                readMoreOnWebShop: 'Du kan læse mere under menupunktet <strong>Webshop</strong>',
                findCode: 'Hvor finder jeg min BikeDNA kode?',
                codeLocation: 'Her finder du din BikeDNA-kode',
                codeLocationDescription: 'Se din BikeDNA-kode på billedet markeret med grønt.',
            },
            selectType: 'Vælg type',
            select: 'Vælg',
            searchForBrand: 'Søg efter mærke',
            bikeData: 'Cykeldata',
            equipmentAndAccessoriesDescription: 'Udstyr og tilbehør der er tilknyttet din cykel',
            Dame: 'Dame',
            Herre: 'Herre',
            Unisex: 'Unisex',
            addEquipment: 'Tilføj {{equipment}} til din cykel',
            lock: 'Lås',
            categories: {
                city: 'City',
                mountainTour: 'Mountain',
                road: 'Road',
                racer: 'Racer',
                cargo: 'Lad',
                hybrid: 'Hybridcykel',
                cruiser: 'Cruiser',
                folding: 'Folde',
                bmx: 'BMX',
            },
            otherType: 'Anden type',
            profile: {
                name: 'Navn',
                languageSection: 'Sprog',
                languageSectionDesc: 'Vælg hvilket systemsprog du ønsker',
                systemLanguageLabel: 'Systemsprog',
                languageDanish: 'Dansk',
                languageEnglish: 'Engelsk',
                languageNorwegian: 'Norsk',
                regionLabel: 'Region',
                regionBikekeyDenmark: 'Bikekey Danmark',
                personalInformationTitle: 'Personlig information',
                personalInformationDesc: 'Opdater din personlige information her',
                verificationTitle: 'Verifikation',
                verificationDesc: 'Se status på din profil verifikation her',
                resendEmailSuccess: 'E-mail sendt afsted',
                mitid: 'MitID',
                verifyNow: 'Verificer nu',
                email: 'Email',
                resendMail: 'Gensend mail',
                deleteUser: 'Slet bruger',
                serverNotResponded: 'Serveren svarede ikke korrekt',
                changesSavedTitle: 'Ændringer er gemt',
                changesSavedDesc: 'Ændringer til kontooplysninger er gemt succesfuldt.',
                changesPartiallySavedTitle: 'Ændringer er delvist gemt',
                changesPartiallySavedDesc:
                    'Vi har sendt en mail til din nye mailadresse - du bedes klikke på linket i mailen før at denne ændring træder i kraft. Alle andre ændringer er gemt succesfuldt.',
                weSentYouAnEmail: 'Vi har sendt dig en email',
                weSentYouAnEmailDesc:
                    'Vi har sendt en mail til din nye mailadresse - du bedes klikke på linket i mailen før at denne ændring træder i kraft.',
                cancelButton: 'Fortryd',
                saveButton: 'Gem',
                address: 'Adresse',
                streetNameAndNumber: 'Vejnavn & nummer',
                city: 'By',
                postalCode: 'Postnummer',
                floor: 'Etage',
                side: 'Side',
                optionalDoor: 'Evt. dør',
                mobile: 'Mobil',
                phone: 'Telefon',
                verification: 'Verifikation',
                seeVerificationStatus: 'Se status på din profilverifikation her',
                resendEmail: 'Gensend mail',
                pendingVerification: 'Mangler verificering',
                verified: 'Du er verificeret',
                systemLanguage: 'Systemsprog',
                region: 'Region',
                navigateToNafCustomerPortal: 'Gå til kundeportalen',
                navigateToNafPurchasePage: 'Gå til NAF købsside',
                nafPeriodeCustomer:
                    'Du har en Vipps-abonnement med NAF, afbryd via Vipps-appen, eller ændre ved at kontakte Bikekey',
                resetPassword: {
                    title: 'Vælg ny adgangskode',
                    description: 'Indtast din ønskede nye adgangskode herunder.',
                    enterNewPassword: 'Indtast adgangskode',
                    enterNewPasswordAgain: 'Gentag adgangskode',
                    save: 'Gem',
                    logInInstead: 'Log ind i stedet',
                    checkMail: 'Check din mail',
                    checkMailDescription:
                        'Vi har sendt et link til at nulstille din adgangskode til {{emailAddress}}',
                    checkMailDescriptionNoMail:
                        'Har du ikke modtaget en mail? Husk at checke dit spamfilter.',
                    sendNewMail: 'Send ny mail',
                    forgotPassword: 'Glemt din adgangskode?',
                    forgotPasswordDescription: 'Intet problem - lad os nulstille det for dig',
                    enterEmail: 'Indtast din email',
                    resetPassword: 'Nulstil adgangskode',
                    invalidEmailAlert: 'Ups - E-mail ikke gyldig',
                    invalidEmailAlertDescription: 'Check om mailadressen er stavet korrekt',
                    invalidEmailAlertNoMail:
                        'Vi kan ikke finde en bruger med den pågældende mailadresse - check om mailadressen er stavet korrekt',
                    invalidEmailAlertDescriptionNoMail:
                        'Vi kan ikke finde en bruger med den pågældende mailadresse - check om mailadressen er stavet korrekt',
                },
            },
            edit: 'Rediger',
            nameNotProvided: 'Navn ikke angivet',
            supportChat: 'Support Chat',
            validButForeignOrManufacturerFrameNumber: 'Gyldigt men udenlandsk-/fabrikantstelnummer',
            takeOrUploadPhotoToHelpFindBike:
                'Tag eller upload et foto af cyklen, som kan hjælpe andre med at finde den.',
            oopsInvalidId: 'Ups - det indtastede ID er ikke gyldigt',
            searchNoResultTitle: 'Søgning gav intet resultat',
            searchNoResultDescription:
                'Din søgning gav desværre ikke et resultat. Check venligst at stel- eller ID-nummer er indtastet korrekt.',
            youOwnThisBike: 'Du ejer denne cykel',
            contactOwner: 'Kontakt ejer',
            requestOwnership: 'Anmod om ejerskab',
            loading: 'Indlæser...',
            loadingMessages: 'Henter samtaler...',
            noMessages: 'Her er ingen beskeder',
            startConversation:
                'Start en samtale ved at scanne en Bikekey nummerplade eller søg på stelnummer.',
            inbox: 'Indbakke',
            searchMessages: 'Søg i beskeder',
            becomePartOfBikekey: 'Bliv en del af Bikekey',
            registerOnDenmarksBikeRegistry: 'Opret dig på Danmarks cykelregister',
            enterYourEmail: 'Indtast din mailadresse',
            enterYourPassword: 'Indtast din adgangskode',
            enterYourPasswordAgain: 'Gentag din adgangskode',
            acceptPrivacyAndTerms:
                'Ved at oprette en bruger på Bikekey accepterer du vores persondatapolitik og forretningsbetingelser.',
            byCreatingUserOnBikekeyYouAccept:
                'Ved at oprette en bruger på Bikekey accepterer du vores',
            privacyPolicy: 'persondatapolitik',
            termsOfService: 'forretningsbetingelser',
            and: 'og',
            createUser: 'Opret bruger',
            alreadyHaveAnAccount: 'Har du allerede en bruger?',
            login: 'Log ind',
            loginToBikekey: 'Log ind på Bikekey',
            welcomeBack: 'Velkommen tilbage! Log ind herunder',
            loginWithMitID: 'Log ind med',
            enterEmail: 'Indtast email',
            enterPassword: 'Indtast adgangskode',
            forgotPassword: 'Jeg har glemt min adgangskode',
            dontHaveAccount: 'Har du ikke en bruger?',
            signUp: 'Opret dig',
            searchFrameOrId: 'Søg på stel- eller ID-nummer',
            search: 'Søg',
            changeUser: 'Skift bruger',
            createBusinessUser: 'Opret forretningsbruger',
            pleaseSelectARegion: 'Vælg venligst en region',
            reportBikeFoundAlert: 'Du er ved at melde din cykel fundet',
            reportBikeFoundAlertDescription:
                'Du skal godkende med MitID for at melde din cykel fundet. Melder du din cykel fundet bliver din anmeldelse slettet og din cykel afmeldt som stjålet på Bikekey registret.',
            reject: 'Afvis',
            helpCenter: 'Hjælpcenter',
            redeemBikeRegistrationTitle: 'Indløs en cykelregistrering',
            redeemBikeRegistrationDescription:
                'Har du købt og modtaget et skilt, f.eks. via vores webshop eller fra en forhandler, så indløs det nedenfor',
            redeemBikeRegistrationButton: 'Indløs registrering',
            registerBikeTitle: 'Gør cykler søgbare og identificerbare',
            registerBikeDescription:
                'Nedenfor er en oversigt over alle tilgængelige cykler knyttet til din konto. Registrer dine cykler med navn og tilhørende nummerskilt-ID. Vi anbefaler også, at du tilføjer et billede af cyklen.',
            bikeNameLabel: 'Navngiv cykel',
            required: 'Krav',
            bikeNamePlaceholder: 'Indtast cykelnavn',
            plateIdLabel: 'Nummerplade ID',
            plateIdPlaceholder: 'Nummerplade ID',
            addBikeButton: 'Tilføj en cykel',
            registerButton: 'Registrer',
            recommended: 'Anbefalet',
            purchase_complete: 'Dit køb hos Bikekey er gennemført.',
            register_info:
                'Du kan først registrere dine cykler, når du har modtaget vores mærkater.',
            delivery_info: 'Du vil modtage mærkaterne med posten inden for 7-10 hverdage.',
            understood_button: 'Forstået',
            waitingConfirmation: 'Venter på bekræftelse',
            paymentProcessingInfo:
                "Det kan tage nogen minutter før betalingen gennemføres. Du kan gå tilbage til app'en og vente. Hvis du tror at der er noget galt er du velkommen til at kontakte os!",
            reloadButton: 'Reload igen',
            goToApp: "Gå til App'en",
            nafMedlemsnummer: 'NAF medlemsnummer',
            nafMedlemsnummerValidering: 'NAF medlemsnummer skal være 6-8 tegn',
            noSubscription: 'Ingen abonnement tilknyttet din konto',
            subscriptionRequiredInfo:
                'Du skal have et aktivt abonnement for at kunne tilføje cykler til din Bikekey-konto.',
            purchaseMembershipButton: 'Køb medlemskab',
            areYouNafMember: 'Er du NAF-medlem?',
            personalInfoTitle: 'Oplysninger om dig',
            personalInfoSubtitle:
                'Check at nedenstående oplysninger om dig er korrekte. Udfyld eventuel information der måtte mangle.',
            firstName: 'Fornavn',
            lastName: 'Efternavn',
            streetAndNumber: 'Vejnavn & nummer',
            city: 'By',
            postalCode: 'Postnummer',
            floor: 'Etage',
            side: 'Side',
            door: 'Evt. dør',
            mobile: 'Mobil',
            telephone: 'Telefon',
            addressTitle: 'Adresse',
            telephoneTitle: 'Telefon',
            next: 'Næste',
            report: 'Anmeldelse',
            overviewTitle: 'Overblik',
            sectionHeader: 'Sektion',
            statusHeader: 'Status',
            goToHeader: 'Gå til',
            personalInfo: 'Oplysninger om dig',
            insuranceAndValue: 'Forsikringsselskab og værdi',
            bikeInfo: 'Oplysninger om din cykel',
            culpritInfo: 'Oplysninger om gerningsperson',
            timeAndPlace: 'Tid og sted for tyveri',
            sendReport: 'Indsend anmeldelse',
            insuranceInfoSubtitle: 'Tilføj detaljer om forsikringsforhold og værdi af din cykel',
            insuranceSingle: 'Forsikring',
            isBikeInsured: 'Er din cykel forsikret?',
            chooseInsuranceCompany: 'Vælg forsikringsselskab',
            bikePriceQuestion: 'Hvad kostede cyklen?',
            bikePriceDescription:
                'Angiv i hele danske kroner, hvad cyklen kostede, inklusiv udstyr. Hvis ikke du ved hvad cyklen kostede, bedes du angive, hvad du vurderer, at en tilsvarende cykel koster.',
            enterAmount: 'Indtast beløb',
            policeReportTitle: 'Skal Bikekey melde din cykel stjålet ved politiet',
            policeReportDescription: 'Vælg om vi skal melde din cykel stjålet ved politiet.',
            noIPreferMyself: 'Nej, det gør jeg selv',
            cprNumber: 'CPR-nummer',
            enterCprNumber: 'Indtast dit CPR-nummer',
            missingStepAlert:
                'Check venligst at alle trin og datafelter er udfyldte før du fortsætter. Sektioner der mangler er angivet med et rødt udråbstegn.',
            missingAcknowledgeTitle: 'Bekræft venligst vores betingelser',
            missingAcknowledgeMessage:
                'Bekræft venligst at du forstår og accepterer ovenstående betingelser for at kunne melde din cykel stjålet på Bikekey.',
            completeAllSteps: 'Udfyld venligst alle trin for at fortsætte',
            bikeInfoTitle: 'Oplysninger om din cykel',
            bikeInfoSubtitle:
                'Check at nedenstående oplysninger om din cykel er korrekte. Udfyld eventuel information der måtte mangle.',
            frameNumberDescription: 'Angiv stelnummeret som det fremgår på stellet af din cykel.',
            bikeCategory: 'Cykelkategori',
            bikeCategoryDescription: 'Angiv hvilken kategori din cykel tilhører.',
            colorDescription: 'Angiv farven på din cykel',
            isElectric: 'El-cykel',
            isElectricDescription: 'Er din cykel en elcykel?',
            batteryDescription: 'Er du i besiddelse af batteriet?',
            lockStatus: 'Låseforhold',
            lockStatusDescription: 'Hvordan var cyklen låst da den blev stjålet',
            writeHere: 'Skriv her...',
            or: 'Eller',
            batteryIntegrated: 'Batteri er integreret i cykel',
            chooseColor: 'Vælg farve',
            chooseCategory: 'Vælg kategori',
            timeAndLocationTitle: 'Tid og sted for tyveri',
            timeAndLocationSubtitle: 'Tilføj detaljer om tid og sted for tyveriet',
            lastSeenTitle: 'Hvornår så du sidst cyklen?',
            dateTimeDescription: 'Angiv dato og tid herunder.',
            discoveredTheftTitle: 'Hvornår opdagede du tyveriet?',
            placeStolenTitle: 'Hvorfra blev cyklen stjålet?',
            placeStolenDescription: 'Vælg placering fra listen',
            locationTitle: 'Lokation',
            locationDescription: 'Indtast placering eller vælg fra kort',
            choosePastDate: 'Vælg venligst en dato i fortiden',
            chooseFallback: 'Vælg',
            searchAddress: 'Søg adresse',
            sendReportTitle: 'Indsend anmeldelse',
            sendReportSubtitle:
                'Ved indsendelse af anmeldelsen vil den blive offentliggjort på Bikekey, hvorefter andre anonymt kan kontakte dig med henblik på at få returneret din cykel.',
            responsibilityAcknowledgement:
                'Jeg er indforstået med, at det er mit eget ansvar at anmelde en skade hos mit forsikringsselskab såfremt jeg vil gøre mig forhåbning om en erstatning.',
            dataShareAcknowledgement:
                'Jeg er indforstået med, at min anmeldelse bliver delt med mit forsikringsselskab.',
            ownershipTransferAcknowledgement:
                'Jeg er indforstået med, at min cykelregistrering overdrages til mit forsikringsselskab, såfremt jeg modtager udbetaling af erstatning.',
            buyMembership: 'Køb medlemskab',
            subscriptionAndPayment: 'Abonnement og betaling',
            checkSubscriptionStatus: 'Tjek status for abonnementet og betalingsmetoden',
            invalidNafNumber: 'Ugyldigt NAF-nummer',
            successFoundTitle: 'Succes! Din cykel er blevet meldt fundet!',
            goToBike: 'Gå til cykel',
            successFoundDescription:
                'Vi er glade for, at din cykel er blevet fundet! Vi har afmeldt den som stjålet på Bikekey.',
            validId: 'Gyldigt ID!',
            reportBikeFoundAlertDescriptionNo:
                'Hvis du melder cyklen fundet, vil din melding blive slettet og cyklen vil blive fjernet fra Bikekey.',
        },
    },
    is: {
        translation: {
            myBikesHeading: 'Mín hjól',
            myBike: 'Mitt hjól',
            registerBike: 'Skrá hjól',
            searchBikesLabel: 'Leita í hjólum',
            searchInRegister: 'Leita í skrá',
            registerBikeSidebar: 'Skrá hjól',
            myBikesSidebar: 'Mín hjól',
            stolenBikes: 'Stolin hjól',
            ownershipTransfer: 'Eigendaskipti',
            webshop: 'Vefverslun',
            insurance: 'Tryggingar',
            messages: 'Skilaboð',
            account: 'Reikningur',
            support: 'Stuðningur',
            insurancePolicies: 'Tryggingarskírteini',
            bikes: 'Hjól',
            bike: 'Reiðhjól',
            addBikePageTitle: 'Skrá hjól',
            createSubscriptionTitle: 'Skrá hjól í Bikekey sykkelregister',
            purchaseOrRedeemExtraBikeTitle: 'Kjøp eller løs inn sykkelregistrering',
            purchaseExtraBikeTitle: 'Kjøp ekstra sykkelmerkning',
            purchaseExtraBikeDescription:
                'Kjøp ekstra sykkelmerking til dine sykler for 100,- kr. pr. stk. som engangsbetaling',
            purchaseExtraBikeButton: 'Kjøp sykkelmerking',
            eBike: 'Rafhjól',
            bikeDetails: 'Hjólaupplýsingar',
            identification: 'Auðkenning',
            active: 'Virkur',
            makeSearchable: 'Gera leitanlegt',
            private: 'Einkamál',
            reportedStolen: 'Tilkynnt stolið',
            editBike: 'Breyta hjóli',
            frameNumber: 'Grindarnúmer',
            missing: 'VANTAR',
            licensePlate: 'Skráningarnúmer',
            optional: 'VALFRJÁLST',
            mayBeRegistered: 'Gæti verið skráð',
            brand: 'Merki',
            category: 'Flokkur',
            color: 'Litur',
            notProvided: 'Ekki tilgreint',
            colors: {
                black: 'Svartur',
                gray: 'Grár',
                blue: 'Blár',
                green: 'Grænn',
                white: 'Hvítur',
                red: 'Rauður',
                special: 'Sérstakur Litur',
                orange: 'Appelsínugulur',
                yellow: 'Gulur',
                brown: 'Brúnn',
                purple: 'Fjólublár',
                multi: 'Marglitur',
                pink: 'Bleikur',
            },
            reportBikeFound: 'Tilkynna hjól fundið',
            seePublicDisplay: 'Sjá opinbera sýningu',
            documents: 'Skjöl',
            equipment: 'Búnaður',
            type: 'Tegund',
            myBikeDetailsBikeTabDescription:
                'Einstöku auðkenni og raðnúmer sem tengja hjólið þitt við þig',
            detailsAndCharacteristicsOfBike: 'Upplýsingar og einkenni hjólsins þíns',
            model: 'Fyrirmynd',
            yes: 'Já',
            no: 'Nei',
            buy: 'Kaup',
            deleteBike: 'Eyða hjóli',
            errors: {
                tagAlreadyRegistered: 'Skráningarnúmer "{{bikekeyId}}" er þegar til',
                tagNotRegistered: 'Ógilt skráningarnúmer "{{bikekeyId}}"',
                fillInFieldsFirst: 'Vinsamlegast fylltu út núverandi hjól fyrst',
                validationError: 'Vinsamlegast fylltu út öll svæði',
            },
            viewTheftReport: 'Sjá stuldarmál',
            reportBikeStolen: 'Tilkynna hjól stolið',
            bikeCannotBeIdentified: 'Ekki er hægt að auðkenna hjólið þitt!',
            toAddFrameAndLicensePlate: 'Til að bæta við ramma og númeraplötu',
            picture: 'Mynd',
            download: 'Sækja',
            addDocumentToBike: 'Bæta við skjali við hjólið þitt.',
            youCanAddFrameNumber: 'Þú getur bætt við grindarnúmeri, kvittun, lásvottorði eða öðru.',
            addEquipmentToBike: 'Bæta við búnaði við hjólið þitt',
            addBatteryOrOtherAccessory: 'Bæta við rafhlöðu eða öðru fylgihluti við hjólið þitt.',
            battery: 'Rafhlaða',
            seeBatteriesForEbike: 'Sjá rafhlöður sem tengjast rafmagnshjólinu þínu.',
            serialNumber: 'Raðnúmer',
            plateId: 'Skráningarnúmer',
            bikeLocks: 'Hjólalásar',
            seeBikeLocks: 'Sjá hjólalása sem tengjast hjólinu þínu.',
            brandAndModel: 'Merki og gerð',
            VarefaktaNumber: 'Varefakta númer',
            accessories: 'Fylgihlutir',
            addVariousAccessories: 'Bæta við ýmsum fylgihlutum við hjólið þitt.',
            logout: 'Útskráning',
            details: 'Upplýsingar',
            importantInformation:
                'Mikilvægar upplýsingar um hjólið þitt sem gera öðrum kleift að bera kennsl á það í gegnum skrána.',
            takePictureFrameNumber: 'Taktu mynd af ramma númerinu á hjólinu þínu',
            takeOneOrMorePictures:
                'Taktu eina eða fleiri myndir af ramma númerinu svo hægt sé að lesa allt ramma númerið á meðal þeirra.',
            pictureOfLicensePlate: 'Mynd af númeraplötu á hjólinu þínu',
            takePictureLicensePlate: 'Taktu mynd af númeraplötu á hjólinu þínu',
            takePictureLicensePlateCode:
                'Taktu mynd af númeraplötu á hjólinu þínu svo hægt sé að lesa kóðann undir QR kóðanum.',
            publicPicture: 'Opinber mynd',
            important: 'Mikilvægt',
            bikePictureOthersSee:
                'Myndin af hjólinu þínu sem aðrir geta séð þegar leitað er í skránni.',
            takePictureEntireBike: 'Taktu mynd af öllu hjólinu þínu',
            makeSureBikeVisible:
                'Gakktu úr skugga um að eins mikið og mögulegt af hjólinu þínu sést á myndinni - það gerir það auðveldara að bera kennsl á það fyrir aðra.',
            pictureOfReceipt: 'Mynd af kvittun fyrir hjólið',
            takePictureReceipt: 'Taktu mynd af kvittuninni fyrir hjólið þitt',
            pictureOfLockProofs: 'Mynd af lásvottorðum',
            takePictureLockProofs: 'Taktu mynd af einu eða fleiri lásvottorðum',
            pictureOfFrameNumber: 'Mynd af grindarnúmeri',
            extraDetails: 'Auka upplýsingar',
            // ... (other translations)
        },
    },
    no: {
        translation: {
            myBikesHeading: 'Mine sykler',
            myBike: 'Min sykkel',
            registerBike: 'Registrer sykkel',
            searchBikesLabel: 'Søk blant syklene dine',
            searchInRegister: 'Søk i registeret',
            registerBikeSidebar: 'Registrer sykkel',
            myBikesSidebar: 'Mine sykler',
            stolenBikes: 'Stjålne sykler',
            ownershipTransfer: 'Eierskapsoverføring',
            webshop: 'Nettbutikk',
            insurance: 'Forsikringer',
            messages: 'Meldinger',
            account: 'Konto',
            support: 'Support',
            insurancePolicies: 'Forsikringspoliser',
            bikes: 'Sykler',
            addBikePageTitle: 'Legg til sykkel',
            createSubscriptionTitle: 'Registrer deg for Bikekey sykkelregister',
            purchaseOrRedeemExtraBikeTitle: 'Kjøp eller løs inn sykkelregistrering',
            purchaseExtraBikeTitle: 'Kjøp ekstra sykkelmerking',
            purchaseExtraBikeDescription:
                'Kjøp ekstra sykkelmerking til dine sykler for 100,- kr. pr. stk. som engangsbetaling',
            purchaseExtraBikeButton: 'Kjøp sykkelmerking',
            bike: 'Sykkel',
            eBike: 'Elsykkel',
            bikeDetails: 'Sykkeldetaljer',
            identification: 'Identifikasjon',
            active: 'Aktiv',
            makeSearchable: 'Gjør søkbar',
            private: 'Privat',
            reportedStolen: 'Meldt stjålet',
            editBike: 'Rediger sykkel',
            frameNumber: 'Rammenummer',
            missing: 'MANGLER',
            licensePlate: 'Oblat',
            optional: 'VALGFRITT',
            mayBeRegistered: 'Kan være registrert',
            brand: 'Merke',
            category: 'Kategori',
            color: 'Farge',
            notProvided: 'Ikke oppgitt',
            colors: {
                black: 'Svart',
                gray: 'Grå',
                blue: 'Blå',
                green: 'Grønn',
                white: 'Hvit',
                red: 'Rød',
                special: 'Spesiell farge',
                orange: 'Oransje',
                yellow: 'Gul',
                brown: 'Brun',
                purple: 'Lilla',
                multi: 'Flerfarget',
                pink: 'Rosa',
            },
            reportBikeFound: 'Rapporter funnet',
            seePublicDisplay: 'Se offentlig visning',
            documents: 'Dokumenter',
            equipment: 'Utstyr',
            type: 'Type',
            myBikeDetailsBikeTabDescription:
                'De unike ID-ene og serienumrene som knytter sykkelen din til deg',
            detailsAndCharacteristicsOfBike: 'Detaljer og kjennetegn ved sykkelen din',
            model: 'Modell',
            yes: 'Ja',
            no: 'Nei',
            buy: 'Kjøp',
            deleteBike: 'Slett sykkel',
            errors: {
                tagAlreadyRegistered: 'Oblat "{{bikekeyId}}" er allerede registrert',
                tagNotRegistered: 'Ugyldig Oblat-ID "{{bikekeyId}}"',
                fillInFieldsFirst: 'Vennligst fyll ut eksisterende sykler først',
                validationError: 'Vennligst fyll ut alle felt',
            },
            viewTheftReport: 'Se tyverirapport',
            reportBikeStolen: 'Rapporter stjålet',
            bikeCannotBeIdentified: 'Sykkelen din kan ikke identifiseres!',
            toAddFrameAndLicensePlate: 'for å legge til rammenummer og nummerplate-ID',
            picture: 'Bilde',
            download: 'Last ned',
            addDocumentToBike: 'Legg til et dokument til sykkelen din.',
            youCanAddFrameNumber:
                'Du kan legge til rammenummer, kvittering, låsebevis eller annet.',
            addEquipmentToBike: 'Legg til utstyr til sykkelen din',
            addBatteryOrOtherAccessory:
                'Legg til et batteri eller annet tilbehør til sykkelen din.',
            battery: 'Batteri',
            seeBatteriesForEbike: 'Se batterier tilknyttet elsykkelen din.',
            serialNumber: 'Serienummer',
            plateId: 'Oblat-ID',
            bikeLocks: 'Sykkellåser',
            seeBikeLocks: 'Se sykkellåser tilknyttet sykkelen din.',
            brandAndModel: 'Merke & modell',
            VarefaktaNumber: 'Varefakta-nummer',
            accessories: 'Tilbehør',
            addVariousAccessories: 'Legg til forskjellige tilbehør til sykkelen din.',
            logout: 'Logg ut',
            details: 'Detaljer',
            importantInformation:
                'Viktig informasjon om sykkelen din som gjør det mulig for andre å identifisere den via registeret.',
            takePictureFrameNumber: 'Ta et bilde av rammenummeret på sykkelen din',
            takeOneOrMorePictures:
                'Ta ett eller flere bilder av rammenummeret slik at hele rammenummeret kan leses i blant dem.',
            pictureOfLicensePlate: 'Bilde av oblaten på sykkelen din',
            takePictureLicensePlate: 'Ta et bilde av oblaten på sykkelen din',
            takePictureLicensePlateCode:
                'Ta et bilde av oblaten på sykkelen din slik at det er mulig å lese koden under QR-koden.',
            publicPicture: 'Offentlig bilde',
            important: 'Viktig',
            bikePictureOthersSee: 'Bildet av sykkelen din som andre kan se ved søk i registeret.',
            takePictureEntireBike: 'Ta et bilde av hele sykkelen din',
            makeSureBikeVisible:
                'Pass på at så mye som mulig av sykkelen din er synlig på bildet - dette gjør den lettere å identifisere for andre.',
            pictureOfReceipt: 'Bilde av sykkelkvittering',
            takePictureReceipt: 'Ta et bilde av kvitteringen for sykkelen din',
            pictureOfLockProofs: 'Bilde av låsebevis',
            takePictureLockProofs: 'Ta et bilde av ett eller flere låsebevis',
            pictureOfFrameNumber: 'Bilde av rammenummer',
            bikeNickName: 'Gi sykkelen din et navn',
            save: 'Lagre',
            saved: 'Lagret',
            nicknameDescription: 'Gi sykkelen din et navn, for eksempel: "Min svarte racer"',
            reset: 'Nullstill',
            enterFrameNumber: 'Skriv inn rammenummer',
            doubleCheckFrameNumber: 'Dobbeltsjekk rammenummeret ditt',
            frameNumberMatchWarning:
                'Det innskrevne rammenummeret må stemme overens med det på sykkelrammen og kan derfor <strong>avvike</strong> fra rammenummeret på kvitteringen din.',
            findFrameNumber: 'Hvor finner jeg rammenummeret?',
            frameNumberLocation:
                'Sykkelens rammenummer kan være plassert flere ulike steder. Nedenfor kan du se de vanligste stedene på sykkelen der rammenummeret er.',
            placeNumberPlate: 'Hvor skal jeg sette oblaten?',
            numberPlatePlacement:
                'Vi anbefaler å plassere oblaten øverst på seterøret vendt mot kjøreretningen, overrøret eller styrerøret. Det viktigste er at den er plassert et sted der den lett kan sees og ikke er skjult av andre deler.',
            findCode: 'Hvor finner jeg koden?',
            findNumberPlateId: 'Finn nummerplate-ID-en din her',
            numberPlateIdLocation:
                'Din nummerplate-ID er den unike sekvensen av tall og bokstaver du finner under QR-koden.',
            seeExample: 'Se eksempel',
            back: 'Tilbake',
            clickToTakeOrUploadPicture: 'Klikk for å ta eller laste opp bilde',
            whereToFindPlateId: 'Hvor finner jeg nummerplate-ID-en min?',
            howToAttachNumberPlates: 'Hvordan fester jeg oblatene?',
            plateShapesAndPlacement:
                'Rektangulær for større rør - rund for bakskjerm eller under krankhuset',
            recommendedPlatePlacement:
                'Vi anbefaler å feste det større rektangulære klistremerket på et av de større rørene på sykkelen din. Vi anbefaler å feste den runde på bakskjermen, eller under krankhuset hvis du ikke har bakskjerm.',
            enterId: 'Skriv inn ID',
            takePictureOfPlate: 'Ta et bilde av oblaten på sykkelen din',
            saveAndFinish: 'Lagre & fullfør',
            continue: 'Fortsett',
            asOnReceipt: 'Som det står på kvitteringen, hvis du har den',
            purchaseDate: 'Kjøpsdato',
            selectDate: 'Velg dato',
            selectPastDate: 'Vennligst velg en dato i fortiden',
            purchasePriceDkk: 'Kjøpspris i DKK',
            privateBikePictures: 'Bilder av sykkelen din som kun du kan få tilgang til på Bikekey',
            privatePictures: 'Private bilder',
            receipt: 'Kvittering',
            form: 'Blankett',
            lockCertificate: 'Låsebevis',
            other: 'Annet',
            extraDetails: 'Ekstra detaljer',
            bikePreventiveFeatures:
                'Kjennetegn og tilbehør for sykkelen din med forebyggende egenskaper som beskytter den mot tyveri',
            bikeDNA: {
                whatIsBikeDNA: 'Hva er BikeDNA?',
                description:
                    'BikeDNA er et ekstra tillegg til din sykkelregistrering. BikeDNA er en gjennomsiktig DNA-væske som inneholder tusenvis av mikroprikker som lyser opp under UV-lys, noe som gjør det mulig for politiet i 40 land å identifisere dine funnede eiendeler og knytte kriminelle til et eventuelt tyveri.',
                readMoreOnWebShop: 'Du kan lese mer under menyelementet <strong>Webshop</strong>',
                findCode: 'Hvor finner jeg BikeDNA-koden min?',
                codeLocation: 'Her finner du BikeDNA-koden din',
                codeLocationDescription: 'Se BikeDNA-koden din på bildet markert med grønt.',
            },
            selectType: 'Velg type',
            select: 'Velg',
            searchForBrand: 'Søk etter merke',
            bikeData: 'Sykkeldata',
            equipmentAndAccessoriesDescription: 'Utstyr og tilbehør som er tilknyttet sykkelen din',
            Dame: 'Dame',
            Herre: 'Herre',
            Unisex: 'Unisex',
            addEquipment: 'Legg til {{equipment}} til sykkelen din',
            lock: 'Lås',
            categories: {
                city: 'By',
                mountainTour: 'Mountain',
                road: 'Landevei',
                racer: 'Racer',
                cargo: 'Lastesykkel',
                hybrid: 'Hybridsykkel',
                cruiser: 'Cruiser',
                folding: 'Sammenleggbar',
                bmx: 'BMX',
            },
            otherType: 'Annen type',
            profile: {
                name: 'Navn',
                languageSection: 'Språk',
                languageSectionDesc: 'Velg hvilket systemspråk du ønsker',
                systemLanguageLabel: 'Systemspråk',
                languageDanish: 'Dansk',
                languageEnglish: 'Engelsk',
                languageNorwegian: 'Norsk',
                regionLabel: 'Region',
                regionBikekeyDenmark: 'Bikekey Danmark',
                personalInformationTitle: 'Personlig informasjon',
                personalInformationDesc: 'Oppdater din personlige informasjon her',
                verificationTitle: 'Verifisering',
                verificationDesc: 'Se status for din profilverifisering her',
                resendEmailSuccess: 'E-post er sendt',
                mitid: 'MitID',
                verifyNow: 'Verifiser nå',
                email: 'E-post',
                resendMail: 'Send e-post på nytt',
                deleteUser: 'Slett bruker',
                serverNotResponded: 'Serveren svarte ikke',
                changesSavedTitle: 'Endringer lagret',
                changesSavedDesc: 'Endringer for kontoen din er lagret.',
                changesPartiallySavedTitle: 'Endringer delvis lagret',
                changesPartiallySavedDesc:
                    'Vi har sendt en e-post til den nye adressen din – vennligst klikk på lenken for å bekrefte. Alle andre endringer er lagret.',
                weSentYouAnEmail: 'Vi har sendt deg en e-post',
                weSentYouAnEmailDesc:
                    'Vi har sendt en e-post til den nye adressen din – vennligst klikk på lenken for å bekrefte endringen.',
                cancelButton: 'Avbryt',
                saveButton: 'Lagre',
                address: 'Adresse',
                streetNameAndNumber: 'Gatenavn og nummer',
                city: 'By',
                postalCode: 'Postnummer',
                floor: 'Etasje',
                side: 'Side',
                optionalDoor: 'Evt. dør',
                mobile: 'Mobil',
                phone: 'Telefon',
                verification: 'Verifisering',
                seeVerificationStatus: 'Se status på din profilverifisering her',
                resendEmail: 'Send e-post på nytt',
                pendingVerification: 'Mangler verifisering',
                verified: 'Du er verifisert',
                systemLanguage: 'Systemspråk',
                region: 'Region',
                navigateToNafCustomerPortal: 'Gå til kundeportalen',
                navigateToNafPurchasePage: 'Gå til NAF kjøpsside',
                nafPeriodeCustomer:
                    'Det er ikke mulig for oss å se status for ditt abonnement eller betalingsmåte hos Vipps.',
                resetPassword: {
                    title: 'Velg nytt passord',
                    description: 'Skriv inn din ønskede nytt passord nedenfor.',
                    enterNewPassword: 'Skriv inn passord',
                    enterNewPasswordAgain: 'Gentag passord',
                    save: 'Lagre',
                    logInInstead: 'Logg inn i stedet',
                    checkMail: 'Sjekk e-post',
                    checkMailDescription:
                        'Vi har sendt et link til at nulstille dere passord til {{emailAddress}}',
                    checkMailDescriptionNoMail:
                        'Har dere ikke modtaget en e-post? Husk at sjekke dit spamfilter.',
                    sendNewMail: 'Send ny e-post',
                    forgotPassword: 'Glemt passordet ditt?',
                    forgotPasswordDescription: 'Ikke noe problem - la oss nullstille det for deg',
                    enterEmail: 'Skriv inn e-post',
                    resetPassword: 'Nullstill passord',
                    invalidEmailAlert: 'Ups - E-post ikke gyldig',
                    invalidEmailAlertDescription: 'Sjekk om e-postadressen er stavet riktig',
                    invalidEmailAlertNoMail:
                        'Vi kan ikke finne en bruker med den angitte e-postadressen - sjekk om e-postadressen er stavet riktig',
                    invalidEmailAlertDescriptionNoMail:
                        'Vi kan ikke finne en bruker med den angitte e-postadressen - sjekk om e-postadressen er stavet riktig',
                },
            },
            edit: 'Rediger',
            nameNotProvided: 'Navn ikke oppgitt',
            supportChat: 'Support Chat',
            validButForeignOrManufacturerFrameNumber: 'Gyldigt men utenlandsk-/fabrikantstelnummer',
            takeOrUploadPhotoToHelpFindBike:
                'Tag eller upload et foto af cyklen, som kan hjælpe andre med at finde den.',
            oopsInvalidId: 'Ups - det indtastede ID er ikke gyldigt',
            searchNoResultTitle: 'Søgning gav intet resultat',
            searchNoResultDescription:
                'Din søgning gav desværre ikke et resultat. Check venligst at stel- eller ID-nummer er indtastet korrekt.',
            youOwnThisBike: 'Du eier denne sykkelen',
            contactOwner: 'Kontakt eier',
            requestOwnership: 'Be om eierskap',
            loading: 'Laster...',
            loadingMessages: 'Henter meldinger...',
            noMessages: 'Her er ingen meldinger',
            startConversation:
                'Start en samtale ved å skanne et Bikekey nummerplade eller søk på stelnummer.',
            inbox: 'Innboks',
            searchMessages: 'Søk i meldinger',
            becomePartOfBikekey: 'Bli en del av Bikekey',
            registerOnDenmarksBikeRegistry: 'Opret deg på Bikekeys & NAFs Sykkelregister',
            enterYourEmail: 'Skriv inn e-postadressen din',
            enterYourPassword: 'Skriv inn passordet ditt',
            enterYourPasswordAgain: 'Gjenta passordet ditt',
            acceptPrivacyAndTerms:
                'Ved at oprette en bruger på Bikekey accepterer du vores persondatapolitik og forretningsbetingelser.',
            byCreatingUserOnBikekeyYouAccept: 'Ved å opprette en bruker på Bikekey godtar du vår',
            privacyPolicy: 'personvernerklæring',
            termsOfService: 'forretningsvilkår',
            and: 'og',
            createUser: 'Opprett bruker',
            alreadyHaveAnAccount: 'Har du allerede en bruker?',
            login: 'Log ind',
            loginToBikekey: 'Logg inn på Bikekey',
            welcomeBack: 'Velkommen tilbake! Logg inn nedenfor',
            loginWithMitID: 'Logg inn med',
            enterEmail: 'Skriv inn e-mail',
            enterPassword: 'Skriv inn passord',
            forgotPassword: 'Jeg har glemt passordet mitt',
            dontHaveAccount: 'Har du ikke en bruker?',
            signUp: 'Registrer deg',
            searchFrameOrId: 'Søk på stel- eller ID-nummer',
            search: 'Søk',
            changeUser: 'Endre bruker',
            createBusinessUser: 'Opprett bedriftsbruker',
            pleaseSelectARegion: 'Vennligst velg en region',
            reportBikeFoundAlert: 'Du er i ferd med å melde sykkelen din funnet',
            reportBikeFoundAlertDescription:
                'Når du melder sykkelen funnet, blir anmeldelsen din slettet og sykkelen avregistrert som stjålet i Bikekey-registeret.',
            reject: 'Avvis',
            helpCenter: 'Hjelpesenter',
            redeemBikeRegistrationTitle: 'Løs inn en sykkelregistrering',
            redeemBikeRegistrationDescription:
                'Har du kjøpt og mottatt skilt, f.eks. via nettbutikken vår eller fra en forhandler, og løs dem inn nedenfor',
            redeemBikeRegistrationButton: 'Løs inn registrering',
            registerBikeTitle: 'Gjør sykler søkbare og identifiserbare',
            registerBikeDescription:
                'Nedenfor er en oversikt over alle tilgjengelige sykler knyttet til kontoen din. Registrer syklene dine med navn og tilhørende nummerskilt-ID. Vi anbefaler at du også legger til et bilde av sykkelen.',
            bikeNameLabel: 'Navn sykkel',
            required: 'Krav',
            bikeNamePlaceholder: 'Indtast sykkelnavn',
            plateIdLabel: 'Nummerskilt ID',
            plateIdPlaceholder: 'Nummerskilt ID',
            addBikeButton: 'Legg til en sykkel',
            registerButton: 'Register',
            recommended: 'Anbefalt',
            purchase_complete: 'Kjøpet ditt på Bikekey er fullført.',
            register_info: 'Du kan først registrere syklene dine når du har mottatt våre oblater.',
            delivery_info: 'Du vil motta oblatene i posten innen 7-10 hverdager.',
            understood_button: 'Det er forstått',
            waitingConfirmation: 'Venter på bekræftelse',
            paymentProcessingInfo:
                'Det kan ta noen minutter før betalingen gjennomføres. Du kan gå tilbake til appen og vente. Hvis du tror at noe er galt, er du velkommen til å kontakte oss!',
            reloadButton: 'Last inn på nytt',
            goToApp: 'Gå til appen',
            nafMedlemsnummer: 'NAF medlemsnummer',
            nafMedlemsnummerValidering: 'NAF medlemsnummer skal være 6-8 tegn',
            noSubscription: 'Ingen abonnement knyttet til kontoen din',
            subscriptionRequiredInfo:
                'Du må ha et aktivt abonnement for å kunne legge til sykler på Bikekey-kontoen din.',
            purchaseMembershipButton: 'Kjøp medlemskap',
            areYouNafMember: 'Er du NAF-medlem?',
            personalInfoTitle: 'Opplysninger om deg',
            personalInfoSubtitle:
                'Sjekk at opplysningene nedenfor om deg er korrekte. Fyll ut eventuell informasjon som mangler.',
            firstName: 'Fornavn',
            lastName: 'Etternavn',
            streetAndNumber: 'Gateadresse og nummer',
            city: 'By',
            postalCode: 'Postnummer',
            floor: 'Etasje',
            side: 'Side',
            door: 'Eventuell dør',
            mobile: 'Mobil',
            telephone: 'Telefon',
            addressTitle: 'Adresse',
            telephoneTitle: 'Telefon',
            next: 'Neste',
            report: 'Anmeldelse',
            overviewTitle: 'Oversikt',
            sectionHeader: 'Seksjon',
            statusHeader: 'Status',
            goToHeader: 'Gå til',
            personalInfo: 'Opplysninger om deg',
            insuranceAndValue: 'Forsikringsselskap og verdi',
            bikeInfo: 'Opplysninger om sykkelen din',
            culpritInfo: 'Opplysninger om gjerningsperson',
            timeAndPlace: 'Tid og sted for tyveriet',
            sendReport: 'Send anmeldelse',
            insuranceInfoSubtitle:
                'Legg til detaljer om forsikringsforhold og verdien av sykkelen din',
            insuranceSingle: 'Forsikring',
            isBikeInsured: 'Er sykkelen din forsikret?',
            chooseInsuranceCompany: 'Velg forsikringsselskap',
            bikePriceQuestion: 'Hva kostet sykkelen?',
            bikePriceDescription:
                'Oppgi prisen i hele norske kroner, inkludert utstyr. Hvis du ikke vet den eksakte prisen, angi hva du mener en tilsvarende sykkel koster.',
            enterAmount: 'Skriv inn beløp',
            policeReportTitle: 'Skal Bikekey melde sykkelen din stjålet til politiet?',
            policeReportDescription: 'Velg om vi skal rapportere tyveriet til politiet for deg.',
            noIPreferMyself: 'Nei, jeg gjør det selv',
            cprNumber: 'Fødselsnummer',
            enterCprNumber: 'Skriv inn fødselsnummeret ditt',
            missingStepAlert:
                'Vennligst sjekk at alle trinn og felt er fylt ut før du fortsetter. Seksjoner som mangler er markert med et rødt utropstegn.',
            missingAcknowledgeTitle: 'Vennligst bekreft våre vilkår',
            missingAcknowledgeMessage:
                'Vennligst bekreft at du forstår og godtar de ovennevnte vilkårene for å kunne melde sykkelen din stjålet på Bikekey.',
            completeAllSteps: 'Vennligst fyll ut alle trinn for å fortsette',
            bikeInfoTitle: 'Opplysninger om sykkelen din',
            bikeInfoSubtitle:
                'Sjekk at opplysningene nedenfor om sykkelen din er riktige. Fyll ut eventuell informasjon som mangler.',
            frameNumberDescription: 'Oppgi rammenummeret slik det står på sykkelens ramme.',
            bikeCategory: 'Sykkelkategori',
            bikeCategoryDescription: 'Oppgi hvilken kategori sykkelen din tilhører.',
            colorDescription: 'Oppgi fargen på sykkelen din',
            isElectric: 'El-sykkel',
            isElectricDescription: 'Er sykkelen din en el-sykkel?',
            batteryDescription: 'Er du i besittelse av batteriet?',
            lockStatus: 'Låseforhold',
            lockStatusDescription: 'Hvordan var sykkelen låst da den ble stjålet?',
            writeHere: 'Skriv her...',
            or: 'Eller',
            batteryIntegrated: 'Batteri er integreret i sykkel',
            chooseColor: 'Velg farge',
            chooseCategory: 'Velg kategori',
            timeAndLocationTitle: 'Tid og sted for tyveriet',
            timeAndLocationSubtitle: 'Legg til detaljer om tidspunkt og sted for tyveriet',
            lastSeenTitle: 'Når så du sykkelen sist?',
            dateTimeDescription: 'Oppgi dato og tid nedenfor.',
            discoveredTheftTitle: 'Når oppdaget du tyveriet?',
            placeStolenTitle: 'Hvor ble sykkelen stjålet fra?',
            placeStolenDescription: 'Velg plassering fra listen',
            locationTitle: 'Lokasjon',
            locationDescription: 'Skriv inn plassering eller velg fra kartet',
            choosePastDate: 'Vennligst velg en dato i fortiden',
            chooseFallback: 'Velg',
            searchAddress: 'Søk adresse',
            sendReportTitle: 'Send anmeldelse',
            sendReportSubtitle:
                'Når du sender inn anmeldelsen, vil den bli publisert på Bikekey, og andre kan anonymt kontakte deg for å returnere sykkelen din.',
            responsibilityAcknowledgement:
                'Jeg er innforstått med at det er mitt eget ansvar å melde en skade til mitt forsikringsselskap dersom jeg ønsker erstatning.',
            dataShareAcknowledgement:
                'Jeg er innforstått med at anmeldelsen min deles med mitt forsikringsselskap.',
            ownershipTransferAcknowledgement:
                'Jeg er innforstått med at sykkelregistreringen min overføres til mitt forsikringsselskap dersom jeg mottar erstatning.',
            buyMembership: 'Kjøp medlemsskap',
            subscriptionAndPayment: 'Abonnement og betaling',
            checkSubscriptionStatus: 'Sjekk statusen til abonnementet og betalingsmåten',
            invalidNafNumber: 'Ugyldig NAF-nummer',
            successFoundTitle: 'Suksess! Sykkelen din har blitt meldt funnet!',
            goToBike: 'Gå til sykkel',
            successFoundDescription:
                'Vi er glade for at sykkelen din har blitt funnet! Vi har avmeldt den som stjålet på Bikekey.',
            validId: 'Gyldigt ID!',
            reportBikeFoundAlertDescriptionNo:
                'Hvis du melder sykkelen fundet, vil din melding blive slettet og sykkelen vil blive fjernet fra Bikekey.',
        },
    },
}
